import dayjs from 'dayjs';
import { handleStartOrEnterEventTracking } from '@/hooks/useEventTracking';
import { useRouteStore } from '@/store/route';

let currentDate = dayjs().format('YYYY-MM-DD');

export const checkDateChange = () => {
  const today = dayjs().format('YYYY-MM-DD');
  const routeStore = useRouteStore();

  if (currentDate !== today) {
    // 如果日期不一样，则跨天了
    currentDate = today; // 更新当前日期
    handleStartOrEnterEventTracking('$AppStart', routeStore.currentRouteName); // 触发事件埋点
  }
};
